import types, { IAction } from '../../types/actions';
import { Product, ProductTree } from '../../types/product';

export interface CategoryState {
	activeItem?: ActiveItem;
	allProducts?: Product[];
	categories?: Categories[];
	categoryProducts: ICategoryFilter[];
	fetchCategory: string;
	filter: {
		input: string;
		modalActiveCategory: string[];
		modalActiveSection: string[];
	};
	productsInputFilter: string;
	productTree: ProductTree[];
}

export interface ActiveItem {
	code: string[];
	type: ActiveItemEnum;
}

export enum ActiveItemEnum {
	SECTION = 'section',
	CATEGORY = 'category',
}

export interface ICategoryFilter {
	code: string;
	codeName: string;
	id: number;
	name: string;
	product: ICategoryFilter[];
	section: ICategoryFilter[] | undefined;
}

export interface Categories {
	code: string;
	image: string;
	name: string;
}

export const initialState: CategoryState = {
	fetchCategory: '',
	categories: undefined,
	categoryProducts: [],
	allProducts: undefined,
	productsInputFilter: '',
	productTree: [],
	activeItem: undefined,
	filter: {
		input: '',
		modalActiveCategory: [],
		modalActiveSection: [],
	},
};

export const categoryReducer = (state = initialState, action: IAction) => {
	switch (action.type) {
		case types.GET_ALL_PRODUCTS_FETCH: {
			return {
				...state,
				fetchCategory: 'FETCH',
			};
		}
		case types.FETCH_MAIN_CATEGORY_START: {
			return {
				...state,
			};
		}
		case types.FETCH_MAIN_CATEGORY_SUCCESS: {
			return {
				...state,
				fetchCategory: 'SUCCESS',
				categories: [...action.payload],
			};
		}
		case types.FETCH_MAIN_CATEGORY_FAILURE: {
			return {
				...state,
				fetchCategory: 'FAILURE',
			};
		}
		case types.GET_ALL_PRODUCTS_SUCCESS: {
			return {
				...state,
				categoryProducts: action.payload, // toto sa moze odstranit vsetko presuvam do All products
				allProducts: action.payload,
				fetchCategory: 'SUCCESS',
			};
		}
		case types.PRODUCTS_FILTER_INPUT_TEXT: {
			return {
				...state,
				productsInputFilter: action.payload,
				activeItem: undefined,
			};
		}
		case types.GET_PRODUCT_TREE_SUCCESS: {
			return {
				...state,
				productTree: action.payload,
			};
		}
		case types.SET_PRODUCT_ACTIVE_ITEM: {
			return {
				...state,
				activeItem: action.payload as ActiveItem,
				productsInputFilter: '',
			};
		}
		case types.RESET_PRODUCT_ACTIVE_ITEM: {
			return {
				...state,
				activeItem: undefined,
			};
		}
		case types.GET_ALL_PRODUCTS_FAILURE: {
			return {
				...state,
				fetchCategory: 'FAILURE',
			};
		}

		case types.SET_PRODUCTS_FILTER: {
			return {
				...state,
			};
		}
		case types.SET_PRODUCTS_FILTER_MODAL: {
			return {
				...state,
				filter: {
					input: action.payload?.input !== undefined ? action.payload?.input : state.filter.input,
					modalActiveCategory: action.payload.category,
					modalActiveSection: action.payload.section,
				},
			};
		}
		case types.SET_PRODUCTS_FILTER_INPUT: {
			return {
				...state,
				filter: {
					input: action.payload,
					modalActiveCategory: [],
					modalActiveSection: [],
				},
			};
		}
		default:
			return state;
	}
};
